import React from 'react';

const FormTextbox = ({
  label,
  placeholder,
  required,
  rows,
  hint,
  horizontal,
  value,
  onChange,
  error,
  defaultValue,
  readOnly,
  disabled,
}) => {
  return (
    <div className={horizontal ? 'row mb-3' : 'mb-3'}>
      {label ? (
        <label
          className={
            required
              ? 'form-label required'
              : horizontal
              ? 'form-label col-3 col-form-label'
              : 'form-label'
          }
        >
          {label}
        </label>
      ) : null}
      <div className={horizontal ? 'col' : null}>
        <textarea
          className={error ? 'form-control is-invalid' : 'form-control'}
          name="textarea-input"
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          defaultValue={defaultValue}
          readOnly={readOnly}
          disabled={disabled}
        />
        {hint ? <small className="form-hint">{hint}</small> : null}
        {error ? <div className="invalid-feedback">{error}</div> : null}
      </div>
    </div>
  );
};

export default FormTextbox;
